import { Injectable } from '@angular/core';
import { EncryptStorage } from 'encrypt-storage';
import { environment } from 'src/environments/environment.development';
@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storage = new EncryptStorage(environment.storage_key, {
    doNotEncryptValues: false,
  });
  private sessionStorage = new EncryptStorage(environment.storage_key, {
    storageType: 'sessionStorage',
    doNotEncryptValues: false,
  });

  getItem(key: string, session: boolean = false) {
    try {
      return (session ? this.sessionStorage : this.storage).getItem(key);
    } catch (err) {
      console.warn(err, 'storage err');
      //alert('storage.service.ts')
      this.clear();
      return null;
    }
  }
  setItem(key: string, value: any, session: boolean = false) {
    (session ? this.sessionStorage : this.storage).setItem(key, value);
  }
  clear() {
    let customerToken: any = null;
    let customerUser: any = null;
    try {
      customerToken = this.storage.getItem('invoicing_customer_token');
      customerUser = this.storage.getItem('invoicing_customer_user');
    } catch (e) {}

    this.storage.clear();
    localStorage.clear();
    sessionStorage.clear();

    try {
      if (customerToken) {
        this.storage.setItem('invoicing_customer_token', customerToken);
      }
      if (customerUser) {
        this.storage.setItem('invoicing_customer_user', customerUser);
      }
    } catch (e) {}
  }
  encryptValue(value: any) {
    return this.storage.encryptValue(value);
  }
  decryptValue(value: any) {
    return this.storage.decryptValue(value);
  }
  removeItem(key: string, session: boolean = false) {
    return (session ? this.sessionStorage : this.storage).removeItem(key);
  }

  constructor() {}
}
